// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"2099":"css/admin-app.6633","8920":"css/app.6633"}[chunkId] + ".css";
};